// extracted by mini-css-extract-plugin
module.exports = {"main":"Text_main__1Jl32","text":"Text_text__3l2wZ","boring":"Text_boring__1Sy2t","text1":"Text_text1__3iC_F"};